import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Typography,
  TextField
} from '@material-ui/core';
import api from '../../../services/api';

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(4), maxWidth: 900 },
  title: { marginBottom: theme.spacing(2) },
  card: { marginBottom: theme.spacing(2) },
  sectionTitle: { fontWeight: 600, marginBottom: theme.spacing(1) },
  actions: { marginTop: theme.spacing(3) },
  message: { marginTop: theme.spacing(2) }
}));

const initial = {
  titularcartaoobg: 'N',
  nrocartaoobg: 'N',
  nsucartaoobg: 'N',
  nroautcartaoobg: 'N',
  vendeservprivporveic: 'N',
  usaclienteporpdv: 'N',
  permitedefpdvdotarifario: 'N',
  exibepaxnaodefcomonoshow: 'N',
  permconsosperiodoantpdvmovel: 'N',
  visqtdediasantes: 0,
  visqtdediasdepois: 0
};

export default function ConfiguracaoGeral() {
  const classes = useStyles();
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const codempresa = Number(sessionStorage.getItem('codEmpresa') || 0);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const r = await api.get('/pdv/configuracoes/geral', { params: { codempresa } });
        if (active) setForm({ ...initial, ...(r.data || {}) });
      } catch (e) {
        if (active) setMessage(e.response?.data?.error || 'Não foi possível carregar as configurações.');
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => { active = false; };
  }, [codempresa]);

  const toggle = (field) => (event) => {
    setMessage('');
    setForm((old) => ({ ...old, [field]: event.target.checked ? 'S' : 'N' }));
  };

  const setDias = (field) => (event) => {
    const value = event.target.value;
    setForm((old) => ({ ...old, [field]: value === '' ? '' : Number(value) }));
  };

  const salvar = async () => {
    if (['visqtdediasantes', 'visqtdediasdepois'].some((field) => !Number.isInteger(Number(form[field])) || form[field] === '' || Number(form[field]) < 0 || Number(form[field]) > 365)) {
      setMessage('Informe dias antes e depois entre 0 e 365.');
      return;
    }
    setSaving(true);
    setMessage('');
    try {
      await api.put('/pdv/configuracoes/geral', { codempresa, ...form });
      setMessage('Configurações salvas com sucesso.');
    } catch (e) {
      setMessage(e.response?.data?.error || 'Não foi possível salvar as configurações.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className={classes.root}><CircularProgress size={28} /></div>;
  }

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.title}>Configurações Gerais do PDV Móvel</Typography>

      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h6" className={classes.sectionTitle}>Campos obrigatórios na forma cartão</Typography>
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={form.titularcartaoobg === 'S'} onChange={toggle('titularcartaoobg')} color="primary" />} label="Nome titular" />
            <FormControlLabel control={<Checkbox checked={form.nrocartaoobg === 'S'} onChange={toggle('nrocartaoobg')} color="primary" />} label="Número cartão" />
            <FormControlLabel control={<Checkbox checked={form.nsucartaoobg === 'S'} onChange={toggle('nsucartaoobg')} color="primary" />} label="NSU" />
            <FormControlLabel control={<Checkbox checked={form.nroautcartaoobg === 'S'} onChange={toggle('nroautcartaoobg')} color="primary" />} label="Autorização" />
          </FormGroup>
        </CardContent>
      </Card>

      <Card className={classes.card}>
        <CardContent>
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={form.vendeservprivporveic === 'S'} onChange={toggle('vendeservprivporveic')} color="primary" />} label="Vende serviço privativo por veículo" />
          </FormGroup>
          <Typography variant="h6" className={classes.sectionTitle} style={{ marginTop: 16 }}>Tarifário</Typography>
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={form.permitedefpdvdotarifario === 'S'} onChange={toggle('permitedefpdvdotarifario')} color="primary" />} label="Define PDV do tarifário" />
            <FormControlLabel control={<Checkbox checked={form.usaclienteporpdv === 'S'} onChange={toggle('usaclienteporpdv')} color="primary" />} label="Usa cliente por PDV" />
            <FormControlLabel control={<Checkbox checked={form.exibepaxnaodefcomonoshow === 'S'} onChange={toggle('exibepaxnaodefcomonoshow')} color="primary" />} label="Exibir pax não definido como show/no-show como no-show no PDV Móvel" />
          </FormGroup>
        </CardContent>
      </Card>

      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h6" className={classes.sectionTitle}>Consulta de OS e escalas — período permitido</Typography>
          <FormControlLabel control={<Checkbox checked={form.permconsosperiodoantpdvmovel === 'S'} onChange={toggle('permconsosperiodoantpdvmovel')} color="primary" />} label="Permite consultar OS de período diferente da data atual - PDV Móvel" />
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 12 }}>
            <TextField label="Dias antes" type="number" variant="outlined" value={form.visqtdediasantes} onChange={setDias('visqtdediasantes')} disabled={form.permconsosperiodoantpdvmovel !== 'S'} inputProps={{ min: 0, max: 365, step: 1 }} />
            <TextField label="Dias depois" type="number" variant="outlined" value={form.visqtdediasdepois} onChange={setDias('visqtdediasdepois')} disabled={form.permconsosperiodoantpdvmovel !== 'S'} inputProps={{ min: 0, max: 365, step: 1 }} />
          </div>
        </CardContent>
      </Card>

      <div className={classes.actions}>
        <Button variant="contained" color="primary" onClick={salvar} disabled={saving}>
          {saving ? 'SALVANDO...' : 'SALVAR'}
        </Button>
      </div>
      {message && <Typography className={classes.message}>{message}</Typography>}
    </div>
  );
}
